import type { z } from 'zod';
import type { LegalBasisModel } from '../projects/_models/project';

export const formatLegalBasis = (
  legalBasis: z.infer<typeof LegalBasisModel>,
): string => {
  return [
    legalBasis.number
      ? `${legalBasis.name}(${legalBasis.number})`
      : legalBasis.name,
    legalBasis.article,
    legalBasis.paragraph,
    legalBasis.paragraphSubIndex,
  ].join(' ');
};
